import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "eleRef",
  class: "zm-tree-org"
}
const _hoisted_2 = { class: "tree-org-node__text" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "tree-org-node__expand-btn" }, null, -1)
const _hoisted_4 = { class: "tree-org-node__text" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "tree-org-node__expand-btn" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tree_org_node = _resolveComponent("tree-org-node")!
  const _component_Draggable = _resolveComponent("Draggable")!
  const _component_Tools = _resolveComponent("Tools")!
  const _component_clone_org = _resolveComponent("clone-org")!
  const _component_Contextmenu = _resolveComponent("Contextmenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "zoomRef",
      class: _normalizeClass(["zoom-container", {'is-center': _ctx.center && !_ctx.horizontal}]),
      style: _normalizeStyle(_ctx.zoomStyle),
      onWheel: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.zoomWheel && _ctx.zoomWheel(...args)))
    }, [
      _createVNode(_component_Draggable, {
        x: _ctx.left,
        y: _ctx.top,
        class: _normalizeClass({ dragging: _ctx.autoDragging }),
        onDragging: _ctx.onDrag,
        onDragstop: _ctx.onDragStop,
        draggable: _ctx.draggable,
        "drag-cancel": _ctx.dragCancel
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref: "treeRef",
            class: _normalizeClass(["tree-org", { horizontal: _ctx.horizontal, collapsable: _ctx.collapsable }])
          }, [
            _createVNode(_component_tree_org_node, {
              data: _ctx.treeData,
              props: _ctx.keys,
              lazy: _ctx.lazy,
              suffix: _ctx.suffix,
              horizontal: _ctx.horizontal,
              labelStyle: _ctx.labelStyle,
              collapsable: _ctx.collapsable,
              renderContent: _ctx.renderContent,
              selectedKey: _ctx.selectedKey,
              defaultExpandLevel: _ctx.defaultExpandLevel,
              selectedClassName: _ctx.selectedClassName,
              labelClassName: _ctx.labelClassName,
              vNodedrag: _ctx.nodeargs,
              onOnExpand: _ctx.handleExpand,
              onNodeClick: _ctx.handleClick,
              onNodeDblclick: _ctx.handleDblclick,
              onNodeMouseenter: _ctx.nodeMouseenter,
              onNodeMouseleave: _ctx.nodeMouseleave,
              onNodeContextmenu: _ctx.nodeContextmenu,
              onNodeFocus: _ctx.handleFocus,
              onNodeBlur: _ctx.handleBlur
            }, _createSlots({ _: 2 }, [
              (_ctx.defaultSlot)
                ? {
                    name: "default",
                    fn: _withCtx(({node}) => [
                      _renderSlot(_ctx.$slots, "default", { node: node }, () => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("span", null, _toDisplayString(node.label), 1)
                        ])
                      ])
                    ])
                  }
                : undefined,
              (_ctx.expandSlot)
                ? {
                    name: "expand",
                    fn: _withCtx(({node}) => [
                      _renderSlot(_ctx.$slots, "expand", { node: node }, () => [
                        _hoisted_3
                      ])
                    ])
                  }
                : undefined
            ]), 1032, ["data", "props", "lazy", "suffix", "horizontal", "labelStyle", "collapsable", "renderContent", "selectedKey", "defaultExpandLevel", "selectedClassName", "labelClassName", "vNodedrag", "onOnExpand", "onNodeClick", "onNodeDblclick", "onNodeMouseenter", "onNodeMouseleave", "onNodeContextmenu", "onNodeFocus", "onNodeBlur"])
          ], 2)
        ]),
        _: 3
      }, 8, ["x", "y", "class", "onDragging", "onDragstop", "draggable", "drag-cancel"])
    ], 38),
    (_ctx.tools.visible)
      ? (_openBlock(), _createBlock(_component_Tools, {
          key: 0,
          tools: _ctx.tools.data,
          scale: _ctx.zoomPercent,
          onOnExpand: _ctx.expandChange,
          onOnScale: _ctx.zoomOrgchart,
          onOnRestore: _ctx.restoreOrgchart,
          onOnFullscreen: _ctx.handleFullscreen
        }, null, 8, ["tools", "scale", "onOnExpand", "onOnScale", "onOnRestore", "onOnFullscreen"]))
      : _createCommentVNode("", true),
    (_ctx.nodeDraggable)
      ? (_openBlock(), _createBlock(_component_clone_org, {
          key: 1,
          modelValue: _ctx.nodeMoving,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nodeMoving) = $event)),
          props: _ctx.keys,
          data: _ctx.cloneData,
          horizontal: _ctx.horizontal,
          "label-style": _ctx.labelStyle,
          collapsable: _ctx.collapsable,
          "render-content": _ctx.renderContent,
          "label-class-name": _ctx.labelClassName
        }, _createSlots({ _: 2 }, [
          (_ctx.defaultSlot)
            ? {
                name: "default",
                fn: _withCtx(({node}) => [
                  _renderSlot(_ctx.$slots, "default", { node: node }, () => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", null, _toDisplayString(node[_ctx.keys.label]), 1)
                    ])
                  ])
                ])
              }
            : undefined,
          (_ctx.expandSlot)
            ? {
                name: "expand",
                fn: _withCtx(({node}) => [
                  _renderSlot(_ctx.$slots, "expand", { node: node }, () => [
                    _hoisted_5
                  ])
                ])
              }
            : undefined
        ]), 1032, ["modelValue", "props", "data", "horizontal", "label-style", "collapsable", "render-content", "label-class-name"]))
      : _createCommentVNode("", true),
    (_ctx.nodeMenus.length)
      ? (_openBlock(), _createBlock(_component_Contextmenu, {
          key: 2,
          modelValue: _ctx.contextmenu,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contextmenu) = $event)),
          x: _ctx.menuX,
          y: _ctx.menuY,
          node: _ctx.menuData,
          data: _ctx.data,
          props: _ctx.keys,
          menus: _ctx.nodeMenus,
          disabled: _ctx.disabled,
          "node-add": _ctx.nodeAdd,
          "node-delete": _ctx.nodeDelete,
          "node-edit": _ctx.nodeEdit,
          "node-copy": _ctx.nodeCopy,
          onContextmenu: _cache[3] || (_cache[3] = 
        (arg) => {
          _ctx.$emit('on-contextmenu', arg);
        }
      ),
          onOnNodeCopy: _cache[4] || (_cache[4] = 
        (txt) => {
          _ctx.$emit('on-node-copy', txt);
        }
      ),
          onOnNodeDelete: _cache[5] || (_cache[5] = 
        (txt) => {
          _ctx.$emit('on-node-delete', txt);
        }
      )
        }, null, 8, ["modelValue", "x", "y", "node", "data", "props", "menus", "disabled", "node-add", "node-delete", "node-edit", "node-copy"]))
      : _createCommentVNode("", true)
  ], 512))
}